(function(){
  document.querySelectorAll(".amc-bs .tabs .tab").forEach(function(t){
    t.addEventListener("click",function(){
      var wrap=t.closest(".amc-bs");
      wrap.querySelectorAll(".tabs .tab").forEach(function(x){x.setAttribute("aria-selected","false");});
      t.setAttribute("aria-selected","true");
      var tab=t.getAttribute("data-tab");
      wrap.querySelectorAll(".amc-panel").forEach(function(p){ p.classList.toggle("is-on", p.getAttribute("data-panel")===tab); });
    });
  });
  var panel=document.getElementById("fPanel");
  if(panel){
    var steps=[
      {q:"Ce înălțime îți dorești?",o:[["Sub 180 cm",""],["180–210 cm",""],["Peste 210 cm",""]]},
      {q:"Ce formă preferi?",o:[["Verde plin","/collections/brazi-verzi"],["Cu zăpadă","/collections/brazi-cu-zapada"],["Slim",""]]},
      {q:"Vrei lumini integrate?",o:[["Cu LED",""],["Fără, pun eu instalația",""]]}
    ];
    var cur=0, dest="/collections/brazi";
    var stepsEl=document.getElementById("fSteps");
    function mark(){ if(!stepsEl) return; stepsEl.querySelectorAll("li").forEach(function(li,i){ li.classList.toggle("is-current",i===cur); li.classList.toggle("is-done",i<cur); }); }
    function render(){
      if(cur>=steps.length){
        panel.innerHTML='<p class="f-note">Gata! Am pregătit brazii care se potrivesc.</p><div class="f-actions"><a class="btn btn-primary" href="'+dest+'">Vezi brazii potriviți</a><button class="f-back" id="fReset" type="button">Începe din nou</button></div>';
        var r=document.getElementById("fReset"); if(r) r.addEventListener("click",function(){cur=0;dest="/collections/brazi";mark();render();});
        return;
      }
      var s=steps[cur], html='<div class="progress">';
      for(var k=0;k<steps.length;k++){ html+='<i class="'+(k<=cur?"on":"")+'"></i>'; }
      html+='</div><div class="f-meta"><span>Pasul '+(cur+1)+' din '+steps.length+'</span>'+(cur>0?'<button class="f-back" id="fBack" type="button">Înapoi</button>':'<span></span>')+'</div><p class="f-q">'+s.q+'</p><div class="opts cols-1">';
      s.o.forEach(function(opt){ html+='<button class="opt" type="button" data-url="'+opt[1]+'"><strong>'+opt[0]+'</strong></button>'; });
      html+='</div>';
      panel.innerHTML=html;
      var b=document.getElementById("fBack"); if(b) b.addEventListener("click",function(){cur=Math.max(0,cur-1);mark();render();});
      panel.querySelectorAll(".opt").forEach(function(o){ o.addEventListener("click",function(){ var u=o.getAttribute("data-url"); if(u) dest=u; cur++; mark(); render(); }); });
    }
    mark(); render();
  }
  var list=document.getElementById("lookList");
  if(list){
    var sumEl=document.getElementById("lookSum"), addBtn=document.getElementById("lookAdd");
    function fmt(c){ return (c/100).toLocaleString("ro-RO")+" lei"; }
    function recalc(){ var t=0; list.querySelectorAll("input[type=checkbox]").forEach(function(cb){ if(cb.checked && !cb.disabled) t+=parseInt(cb.getAttribute("data-price"),10)||0; }); if(sumEl) sumEl.textContent=fmt(t); }
    list.addEventListener("change",recalc); recalc();
    if(addBtn) addBtn.addEventListener("click",function(){
      var items=[]; list.querySelectorAll("input[type=checkbox]").forEach(function(cb){ if(cb.checked && !cb.disabled){ items.push({id:parseInt(cb.getAttribute("data-id"),10),quantity:1}); } });
      if(!items.length){ return; }
      addBtn.disabled=true; addBtn.textContent="Se adaugă…";
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();}).then(function(){ window.location="/cart"; })
        .catch(function(){ addBtn.disabled=false; addBtn.textContent="Adaugă decorul în coș"; });
    });
  }
})();
